export const BRAND_NAME = "GROTALIS";
export const BRAND_DESCRIPTOR = "The Private Cellar";

// Stone arch entrance with keystone and keyhole
export const GrotalisMark = ({ color = "#C6A76E", size = 48, bold = false, title = "GROTALIS" }) => {
  const s = bold ? 5 : 3;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label={title} fill="none">
      <path d="M12 57V29a20 20 0 0 1 40 0v28" stroke={color} strokeWidth={s} strokeLinecap="square" />
      {!bold && <path d="M20 57V31a12 12 0 0 1 24 0v26" stroke={color} strokeWidth={1.5} />}
      <path d="M7 58h50" stroke={color} strokeWidth={s} />
      <path d="M28.6 5.5h6.8l-1.2 6.5h-4.4z" fill={color} />
      <circle cx="32" cy={bold ? 36 : 38} r={bold ? 5 : 3.6} fill={color} />
      <path d={bold ? "M29.4 39h5.2l1.4 11h-8z" : "M30.3 40.5h3.4l1.1 8.5h-5.6z"} fill={color} />
    </svg>
  );
};

export const GrotalisLogo = ({ color = "#C6A76E", sub = "#A6A49C", size = 40, showSub = true }) => (
  <span className="inline-flex items-center gap-3" aria-label="GROTALIS — The Private Cellar">
    <GrotalisMark color={color} size={size} />
    <span className="leading-none">
      <span className="g-serif block font-semibold" style={{ color, fontSize: size * 0.62, letterSpacing: "0.14em" }}>{BRAND_NAME}</span>
      {showSub && <span className="block mt-1" style={{ color: sub, fontSize: Math.max(9, size * 0.24), letterSpacing: "0.08em" }}>{BRAND_DESCRIPTOR}</span>}
    </span>
  </span>
);
